import { toast } from 'react-toastify';

import CustomToastCloseButton from 'Components/CustomCloseButtonToast';

const commonReactToastifyProps = {
  position: 'bottom-center',
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: CustomToastCloseButton,
};

export const errorReactToastify = (message, props) => toast.error(message, {
  ...commonReactToastifyProps,
  ...props,
});

export const successReactToastify = (message, props) => toast.success(message, {
  ...commonReactToastifyProps,
  ...props,
});

export const infoReactToastify = (message, props) => toast.info(message, {
  ...commonReactToastifyProps,
  ...props,
});
